module.exports = __webpack_public_path__ + "static/media/24_tn.76032e51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/24_tn.jpg
// module id = 512
// module chunks = 0